export const getDirectChildElementsByTag = (parent: Element, tagName: string): Element[] => {
  const wanted = tagName.toLowerCase();
  return Array.from(parent.children).filter((child) => child.tagName.toLowerCase() === wanted);
};

export const getFirstDirectChildByTag = (parent: Element, tagName: string): Element | undefined =>
  getDirectChildElementsByTag(parent, tagName)[0];
